var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"i_fcst_tem"},[_c('div',{staticClass:"t_line"}),_c('div',{staticClass:"t_drag",staticStyle:{"top":"-15px"}},[_c('p',[_vm._v("100hpa")]),_c('p',[_vm._v("15900米")])])])])
}]

export { render, staticRenderFns }